import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { UsersService } from '../../shared/services/users.service';
import { AuthService } from '../../shared/auth/auth.service';
import swal from 'sweetalert2';

import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  form: FormGroup;
  loading = false;
  constructor(
    private formBuilder: FormBuilder,
    private usersService: UsersService,
    private authService: AuthService,
    private toastrService: ToastrService
  ) {
    this.form = this.initUserFormGroup();
  }

  initUserFormGroup(): FormGroup {
    const formControls = {
      displayName: [null, Validators.required],
      email: [null, Validators.required],
      password: [null, Validators.required],
      cpassword: [null, Validators.required],
      type: ['user', Validators.required],
      gender: null
    };
    return this.formBuilder.group(formControls, {
      validator: this.usersService.checkIfMatchingPasswords('password', 'cpassword')
    });
  }

  ngOnInit() {}

  //  On submit click, reset field value
  onSubmit() {
    this.loading = true;
    this.authService
      .signup(this.form.get('email').value, this.form.get('password').value, this.form.value)
      .then((res: any) => {
        if (res.error) {
          this.loading = false;
          this.toastrService.error(res.error, 'Error!');
        } else {
          this.form.reset();
          // this.toastrService.success('Create user', 'Success!');
          swal('Regis', 'Success!', 'success');
          // console.log(res);
          this.loading = false;
        }
      })
      .catch(err => {
        console.log(err);
        this.loading = false;
        this.toastrService.error(err.message, 'Error!');
      });
  }
}
